module.exports = __webpack_public_path__ + "img/icon_sm.7553f910.jpg";